const NAMESPACE = 'TRANSACTIONS';
// Historycal data sync
export const TX_SYNC_REQ = `${NAMESPACE}/TX_SYNC_REQ`;
export const TX_SYNC_OK = `${NAMESPACE}/TX_SYNC_OK`;
export const TX_SYNC_FAIL = `${NAMESPACE}/TX_SYNC_FAIL`;
export const TX_NEW_TX = `${NAMESPACE}/TX_NEW_TX`;
// Send transaction
export const TX_SEND_REQ = `${NAMESPACE}/TX_SEND_REQ`;
export const TX_SEND_OK = `${NAMESPACE}/TX_SEND_OK`;
export const TX_SEND_FAIL = `${NAMESPACE}/TX_SEND_FAIL`;
export const TX_SEND_CONFIRMED = `${NAMESPACE}/TX_SEND_CONFIRMED`;
export const TX_SEND_FAILED = `${NAMESPACE}/TX_SEND_FAILED`;

// Etherscan
export const TX_ETHERSCAN_REQ = `${NAMESPACE}/TX_ETHERSCAN_REQ`;
export const TX_ETHERSCAN_OK = `${NAMESPACE}/TX_ETHERSCAN_OK`;
export const TX_ETHERSCAN_FAIL = `${NAMESPACE}/TX_ETHERSCAN_FAIL`;

